import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { CssBaseline } from '@material-ui/core';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { BrowserRouter as Router, Route, Switch, useParams } from 'react-router-dom';
import { isMobile } from '../src/utils';

import App from './App';
import AppStateProvider, { useAppState } from './state';
import ErrorDialog from './components/ErrorDialog/ErrorDialog';
import PrivateRoute from './components/PrivateRoute/PrivateRoute';
import theme from './theme';
import './types';
import { ChatProvider } from './components/ChatProvider';
import { ParticipantProvider } from './components/ParticipantProvider';
import { VideoProvider } from './components/VideoProvider';
import useConnectionOptions from './utils/useConnectionOptions/useConnectionOptions';
import UnsupportedBrowserWarning from './components/UnsupportedBrowserWarning/UnsupportedBrowserWarning';
import { ToastProvider } from './components/ToastProvider/ToastProvider';
import 'leaflet/dist/leaflet.css';
import { LocationProvider } from './contexts/LocationContext';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

const containerStyle = {
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const bannerStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '20%',
  width: '100%',
};

function LoadingBanner({ text, color }: { text: string; color: string }) {
  return (
    <div style={containerStyle}>
      <div style={{ ...bannerStyle, backgroundColor: color }}>
        <p style={{ color: 'white', fontSize: isMobile ? '100%' : '200%' }}>
          <ErrorOutlineIcon style={{ marginRight: 8 }} /> &nbsp;{text}
        </p>
      </div>
    </div>
  );
}

const VideoAppWrapper = () => {
  const { URLModulo, URLRoomName } = useParams<{ URLModulo: string; URLRoomName: string }>();
  const { error, setError } = useAppState();
  const [status, setStatus] = useState<'loading' | 'error' | 'inativo' | 'ok'>('loading');
  const connectionOptions = useConnectionOptions();

  useEffect(() => {
    let verificacao = false;

    fetch(`https://cosmos.ativapericias.com.br/auto/${URLModulo}/${URLRoomName}`, {
      method: 'GET',
      mode: 'cors',
    })
      .then(res => {
        if (!res.ok) throw new Error('Erro ao buscar');
        return res.json();
      })
      .then(data => {
        switch (URLModulo) {
          case 'telereg':
            verificacao = data.reg_disponiveltele === 'ativo';
            break;

          case 'teleinsp':
            verificacao = data.ins_disponiveltele === 'ativo';
            break;
        }

        if (verificacao) {
          setStatus('ok');
        } else {
          setStatus('inativo');
        }
      })
      .catch(() => setStatus('error'));
  }, [URLModulo, URLRoomName]);

  if (status === 'loading') return <LoadingBanner text="Buscando dados" color="#326afa" />;
  if (status === 'error') return <LoadingBanner text="Erro! Essa página não está disponível." color="#eb4034" />;
  if (status === 'inativo') return <LoadingBanner text="Processo Inativo" color="#eb4034" />;

  return (
    <LocationProvider>
      <VideoProvider options={connectionOptions} onError={setError}>
        <ToastProvider>
          <ErrorDialog dismissError={() => setError(null)} error={error} />
          <ParticipantProvider>
            <ChatProvider>
              <App />
            </ChatProvider>
          </ParticipantProvider>
        </ToastProvider>
      </VideoProvider>
    </LocationProvider>
  );
};

export const ReactApp = () => (
  <MuiThemeProvider theme={theme}>
    <CssBaseline />
    <UnsupportedBrowserWarning>
      <Router>
        <AppStateProvider>
          <Switch>
            {/* <PrivateRoute exact path="/">
              <VideoApp />
            </PrivateRoute> */}
            <PrivateRoute path="/:URLModulo/room/:URLRoomName">
              <VideoAppWrapper />
            </PrivateRoute>
            {/* <Route path="/login">
              <LoginPage />
            </Route> */}
            {/* <Redirect to="/" /> */}
          </Switch>
        </AppStateProvider>
      </Router>
    </UnsupportedBrowserWarning>
  </MuiThemeProvider>
);

ReactDOM.render(<ReactApp />, document.getElementById('root'));
